var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-middle w-full py-3"},[_c('h1',{staticClass:"headline"},[(_vm.icon)?_c('icon',{staticClass:"h-6 w-6 inline mr-2 pb-1",attrs:{"name":_vm.icon}}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }